// extracted by mini-css-extract-plugin
module.exports = {"diagramCard":"styles_diagramCard__2wEJt","diagramCardSubHeader":"styles_diagramCardSubHeader__35CWM","files":"styles_files__1RmZA"};